/**
 * We infer 'employee' status based on the presence of internal domain emails.
 *
 * This is because some operations want to filter out internal users but not all employees will be
 * using their admin accounts at all times. Some times they may use test accounts with other roles and permissions.
 */
export const isInternalEmail = (emails = []) => {
  const targetEmails = process.env.REACT_APP_INTERNAL_DOMAIN_ADDRESSES || '';
  return targetEmails
    .split(',')
    .some(domain =>
      emails?.some(email => email?.address?.toLowerCase().includes(domain))
    );
};
